document.addEventListener('DOMContentLoaded', (event) => {
  const links = document.querySelectorAll('.live-advisory_link');
  const mediaQuery =  window.matchMedia(' (min-width:768px) ');
  var isMobile =  false;
  function openAdvisoryWidget(greetingDesktopID="",greetingMobileID="") {
    isMobile = !mediaQuery.matches;
    if(greetingDesktopID !="" && greetingMobileID !="") {
      let greetingID = isMobile?greetingMobileID:greetingDesktopID;
      window.adaEmbed.reset({ greeting: greetingID });
    }
    else {
      window.adaEmbed.reset({ greeting: "" });
    }
    window.adaEmbed.toggle();
  }
  links.forEach(link => {
    var desktopData = link.dataset.greetingdesktop;
    var mobileData = link.dataset.greetingmobile;
    link.onclick = function() {openAdvisoryWidget(desktopData,mobileData)};
  });
});
